import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { errMsg } from "@/lib/api";
import { Lock, Loader2 } from "lucide-react";

export default function Login() {
  const { user, login, t, lang, setLang } = useApp();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try { await login(email, password); } catch (x) { setErr(errMsg(x)); }
    setBusy(false);
  };
  return (
    <div className="min-h-screen grid lg:grid-cols-[1.2fr_1fr] bg-background">
      <div className="relative hidden lg:flex flex-col justify-between p-12 overflow-hidden border-r grid-bg">
        <div className="absolute -right-40 top-1/2 -translate-y-1/2 w-[640px] h-[640px] rounded-full border border-primary/20">
          <div className="absolute inset-16 rounded-full border border-primary/15" />
          <div className="absolute inset-36 rounded-full border border-primary/10" />
          <div className="radar-sweep absolute inset-0 rounded-full" style={{ background: "conic-gradient(from 0deg, hsl(var(--primary)/0.22), transparent 25%)" }} />
        </div>
        <div className="gabon-bar w-24 relative" />
        <div className="relative max-w-lg">
          <img src="/logo.png" alt="MADENGI" className="w-48 mb-8 drop-shadow-2xl" />
          <h1 className="text-5xl font-extrabold tracking-tight leading-[1.05]">Renseignement numérique <span className="gold-text">souverain</span>.</h1>
          <p className="text-muted-foreground mt-5 leading-relaxed">Recherche multisource, empreintes numériques, analyse d'images, suivi aéronautique ADS-B, Cyber Threat Intelligence et assistant analytique traçable — sans abonnement, sans fonctionnalité verrouillée.</p>
        </div>
        <div className="relative flex gap-6 font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
          <span>Sources ouvertes</span><span>·</span><span>Traçabilité</span><span>·</span><span>RBAC</span>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5 fade-up" data-testid="login-form">
          <img src="/logo.png" alt="" className="w-20 lg:hidden" />
          <div>
            <div className="eyebrow mb-2 flex items-center gap-2"><Lock size={11} /> {t("login_title")}</div>
            <h2 className="text-2xl font-bold">MADENGI</h2>
            <p className="text-sm text-muted-foreground mt-1">{t("login_sub")}</p>
          </div>
          <div className="space-y-1.5">
            <label className="eyebrow">{t("email")}</label>
            <input data-testid="login-username-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full h-11 px-3 rounded-md bg-card border font-mono text-sm focus:outline-none focus:ring-2 focus:ring-primary/40" />
          </div>
          <div className="space-y-1.5">
            <label className="eyebrow">{t("password")}</label>
            <input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full h-11 px-3 rounded-md bg-card border font-mono text-sm focus:outline-none focus:ring-2 focus:ring-primary/40" />
          </div>
          {err && <div data-testid="login-error" className="text-sm text-rose-500 border border-rose-500/30 bg-rose-500/10 rounded p-2">{err}</div>}
          <button data-testid="login-submit-button" disabled={busy} className="w-full h-11 rounded-md bg-primary text-primary-foreground font-semibold flex items-center justify-center gap-2 hover:opacity-90 disabled:opacity-60">
            {busy && <Loader2 size={16} className="animate-spin" />} {t("sign_in")}
          </button>
          <div className="flex justify-between text-[11px] text-muted-foreground">
            <span>Comptes créés par un administrateur (RBAC).</span>
            <button type="button" data-testid="login-language-toggle" onClick={() => setLang(lang === "fr" ? "en" : "fr")} className="font-mono hover:text-primary">{lang === "fr" ? "EN" : "FR"}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
